import React from "react";

const PlaySection = () => {
  return (
    <>
      <div class="content_2_uni_head">
        <div>
          <h1>How to play</h1>
        </div>
      </div>

      <div class="content_2_uni_wrapper">
        <div>
          <div class="content_2_content_text">
            <p>
              <strong>
                Kickstart Your Fantasy Cricket Adventure with aufantasy
              </strong>
              <br />
              Dive into the thrilling realm of aufantasy and take charge of your
              cricket journey. Follow these simple steps to begin your path to
              victory today!
            </p>

            <p>
              <strong>Step 1: Download the aufantasy App</strong>
              <br />
              Head over to the aufantasy website and click the &ldquo;Download
              App&rdquo; button. The app will automatically download onto your
              device. Once installed, open the app and immerse yourself in the
              fantasy cricket universe!
            </p>

            <p>
              <strong>Step 2: Register and Log In</strong>
              <br />
              Open the app and complete a quick registration by entering your
              details. Once registered, log in to access your personalized
              dashboard, where you can manage teams, track progress, and stay
              updated on upcoming matches.
            </p>

            <p>
              <strong>Step 3: Assemble Your Dream Team</strong>
              <br />
              Time to build your winning lineup! Pick players based on
              performance stats, current form, and match conditions. Whether
              it&rsquo;s a 2-player, 3-player, or 4-player contest, strategize
              carefully for the best chance of success. Don&rsquo;t forget to
              lock in your team before the match begins!
            </p>

            <p>
              <strong>Step 4: Create or Join Exciting Challenges</strong>
              <br />
              Enhance your fantasy cricket experience by participating in
              challenges:
            </p>

            <ul>
              <li>Log in and select &ldquo;Create Challenge.&rdquo;</li>
              <li>Choose your match and team size (2, 3, or 4 players).</li>
              <li>
                For smaller teams, pick at least one player from each side; for
                larger ones, select two per side.
              </li>
              <li>
                Set the stakes and decide between a Public (open to all) or
                Private (friends-only) challenge.
              </li>
            </ul>

            <p>
              <strong>Step 5: Compete, Earn Points, and Win</strong>
              <br />
              With your team set and challenges live, it&rsquo;s game time! Test
              your cricket knowledge, rise up the leaderboard, and savor your
              victories. Each match presents a new opportunity to showcase your
              strategy and dominate the fantasy cricket stage.
            </p>

            <p>
              <strong>Join aufantasy Today!</strong>
              <br />
              Don&rsquo;t wait&mdash;become a part of the action and turn every
              match into your next triumph!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlaySection;
